(function () {
  'use strict';

  if (window.__mtPdpCargado) return;
  window.__mtPdpCargado = true;

  function formatear(centimos) {
    return (centimos / 100).toLocaleString('es-ES', {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
    });
  }

  function reproducirCuandoPueda(video) {
    if (!video) return;
    var intento = video.play();
    if (intento && intento.catch) intento.catch(function () {});
  }

  /* ---------- Giro 360 de la primera diapositiva ---------- */
  function initGiro() {
    document.querySelectorAll('[data-mt-spin]').forEach(function (spin) {
      var frames = spin.querySelectorAll('.mt-pdp__giro-frame');
      if (frames.length < 2) return;
      var ms = (parseInt(spin.getAttribute('data-mt-spin-ms'), 10) || 14) * 100;
      var idx = 0;
      setInterval(function () {
        // Con la diapositiva oculta no se anima: ahorra repintados inútiles.
        if (!spin.classList.contains('is-activa')) return;
        frames[idx].classList.remove('is-active');
        idx = (idx + 1) % frames.length;
        frames[idx].classList.add('is-active');
      }, ms);
    });
  }

  /* ---------- Vídeos de sección: arrancan al entrar en pantalla ---------- */
  // Con solo el atributo autoplay, Chrome no siempre arranca un vídeo que está
  // fuera de la ventana al cargar la página: se queda en el primer fotograma.
  // Con el observador se lanza justo cuando se ve, y se pausa al salir.
  function initVideosSeccion() {
    var videos = document.querySelectorAll('.mt-pdpvid__marco video');
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      videos.forEach(reproducirCuandoPueda);
      return;
    }

    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) reproducirCuandoPueda(e.target);
        else if (!e.target.paused) e.target.pause();
      });
    }, { threshold: 0.25 });

    videos.forEach(function (v) { io.observe(v); });
  }

  /* ---------- Galería: visor + miniaturas ---------- */
  function initGaleria() {
    document.querySelectorAll('[data-mt-galeria]').forEach(function (galeria) {
      var diapos = galeria.querySelectorAll('[data-mt-diapo]');
      var minis = galeria.querySelectorAll('[data-mt-mini]');
      if (!diapos.length) return;

      function mostrar(clave) {
        diapos.forEach(function (d) {
          var activa = d.getAttribute('data-mt-diapo') === String(clave);
          d.classList.toggle('is-activa', activa);
          var v = d.querySelector('video');
          if (v) { activa ? reproducirCuandoPueda(v) : v.pause(); }
        });
        minis.forEach(function (m) {
          m.classList.toggle('is-activa', m.getAttribute('data-mt-mini') === String(clave));
        });
      }

      minis.forEach(function (m) {
        m.addEventListener('click', function () { mostrar(m.getAttribute('data-mt-mini')); });
      });

      var inicial = galeria.querySelector('.mt-pdp__diapo.is-activa video');
      if (inicial) reproducirCuandoPueda(inicial);

      galeria.__mtMostrarPorSrc = function (src) {
        if (!src) return;
        var nombre = src.split('?')[0].split('/').pop();
        for (var i = 0; i < diapos.length; i++) {
          var d = diapos[i].getAttribute('data-mt-src');
          if (d && d.split('?')[0].split('/').pop() === nombre) {
            mostrar(diapos[i].getAttribute('data-mt-diapo'));
            return;
          }
        }
      };
    });
  }

  /* ---------- Existencias por variante ---------- */
  // -1 = sin límite. Lo pinta Liquid en [data-mt-stock-json].
  function leerStock(form) {
    var el = (form || document).querySelector('[data-mt-stock-json]')
          || document.querySelector('[data-mt-stock-json]');
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  }

  function stockDe(form) {
    var mapa = leerStock(form);
    var input = (form || document).querySelector('input[name="id"]');
    if (!input) return -1;
    var n = mapa[input.value];
    return (n === undefined) ? -1 : n;
  }

  function avisoDe(form) {
    return (form || document).querySelector('[data-mt-stock-aviso]')
        || document.querySelector('[data-mt-stock-aviso]');
  }

  function mostrarAviso(form, texto, permanente) {
    var el = avisoDe(form);
    if (!el) return;
    if (!texto) { el.hidden = true; el.textContent = ''; return; }
    el.textContent = texto;
    el.hidden = false;
    if (el.__mtTimer) clearTimeout(el.__mtTimer);
    if (!permanente) {
      el.__mtTimer = setTimeout(function () { el.hidden = true; }, 6000);
    }
  }

  /* ---------- Tramos de descuento por cantidad ---------- */
  function initTramos() {
    document.querySelectorAll('[data-mt-tramos]').forEach(function (caja) {
      var form = caja.closest('form') || document;
      var cantidad = form.querySelector('[data-mt-qty] input');
      var boton = form.querySelector('[data-mt-add-btn]');
      var tramos = caja.querySelectorAll('[data-mt-tramo-cantidad]');
      if (!tramos.length) return;

      // Apaga los packs que no caben en las existencias de la variante elegida
      // y, si el pack activo deja de caber, baja al mayor que sí quepa.
      function aplicarStock() {
        var stock = stockDe(form);
        var permitidos = [];

        tramos.forEach(function (t) {
          var n = parseInt(t.getAttribute('data-mt-tramo-cantidad'), 10) || 1;
          var cabe = (stock < 0) || (n <= stock);
          t.classList.toggle('is-sin-stock', !cabe);
          var radio = t.querySelector('.mt-pdp__tramo-radio');
          if (radio) radio.disabled = !cabe;
          if (cabe) permitidos.push(n);
        });

        if (cantidad) cantidad.max = stock < 0 ? '' : String(stock);

        var actual = parseInt(cantidad && cantidad.value, 10) || 1;
        if (stock >= 0 && actual > stock && permitidos.length) {
          cantidad.value = Math.max.apply(null, permitidos);
          cantidad.dispatchEvent(new Event('change', { bubbles: true }));
        }

        var plantilla = (avisoDe(form) || {}).dataset
          ? avisoDe(form).getAttribute('data-mt-texto-quedan') : '';
        var hayApagados = permitidos.length !== tramos.length;
        if (stock >= 0 && hayApagados && plantilla) {
          mostrarAviso(form, plantilla.replace('{n}', stock), true);
        } else {
          mostrarAviso(form, '');
        }
      }

      document.addEventListener('mt:variante-actualizada', function () {
        setTimeout(aplicarStock, 0);
      });
      caja.__mtAplicarStock = aplicarStock;

      // El botón muestra el total del tramo elegido, no el precio unitario.
      function pintarBoton(tramo) {
        if (!boton || boton.disabled) return;
        var texto = boton.getAttribute('data-mt-add-text') || 'Añadir';
        var total = tramo && parseInt(tramo.getAttribute('data-mt-tramo-total'), 10);
        if (total > 0) boton.textContent = texto + ' · ' + formatear(total);
      }

      function marcar() {
        var actual = parseInt(cantidad && cantidad.value, 10) || 1;
        var elegido = null;
        tramos.forEach(function (t) {
          var n = parseInt(t.getAttribute('data-mt-tramo-cantidad'), 10) || 0;
          var activo = n === actual;
          t.classList.toggle('is-activo', activo);
          var radio = t.querySelector('.mt-pdp__tramo-radio');
          if (radio) radio.checked = activo;
          if (activo) elegido = t;
        });
        if (elegido) pintarBoton(elegido);
      }

      tramos.forEach(function (t) {
        t.addEventListener('click', function (e) {
          if (!cantidad) return;
          // Los packs que no caben en el stock no se pueden elegir.
          if (t.classList.contains('is-sin-stock')) {
            e.preventDefault();
            return;
          }
          cantidad.value = parseInt(t.getAttribute('data-mt-tramo-cantidad'), 10) || 1;
          cantidad.dispatchEvent(new Event('change', { bubbles: true }));
          marcar();
        });
      });

      if (cantidad) {
        ['change', 'input'].forEach(function (ev) {
          cantidad.addEventListener(ev, marcar);
        });
        var cajaQty = form.querySelector('[data-mt-qty]');
        if (cajaQty) cajaQty.addEventListener('click', function () { setTimeout(marcar, 0); });
      }

      // Cuando el selector de variantes reescribe el botón, hay que volver a
      // poner el total del tramo o se quedaría el precio de una sola unidad.
      document.addEventListener('mt:variante-actualizada', function () {
        setTimeout(marcar, 0);
      });

      aplicarStock();
      marcar();
    });
  }

  /* ---------- Selector de variantes ---------- */
  function initVariantes() {
    document.querySelectorAll('[data-mt-product-form]').forEach(function (form) {
      var dataEl = form.querySelector('[data-mt-variants-json]');
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var idInput = form.querySelector('input[name="id"]');
      var priceEl = form.querySelector('[data-mt-price]');
      var compareEl = form.querySelector('[data-mt-compare]');
      var addBtn = form.querySelector('[data-mt-add-btn]');
      var opciones = form.querySelectorAll('[data-mt-option-index]');
      if (!opciones.length) opciones = document.querySelectorAll('[data-mt-option-index]');
      var seccion = form.closest('[data-mt-producto]');
      // En la primera pasada NO se toca la galería: la ficha debe abrir por el
      // giro, no saltar a la foto de la variante por defecto.
      var primeraPasada = true;

      function seleccion() {
        var sel = {};
        opciones.forEach(function (btn) {
          var elegido = btn.tagName === 'INPUT' ? btn.checked : btn.classList.contains('is-selected');
          if (elegido) sel[btn.getAttribute('data-mt-option-index')] = btn.getAttribute('data-mt-value');
        });
        return sel;
      }

      function buscarVariante(sel) {
        return variants.find(function (v) {
          return Object.keys(sel).every(function (i) { return v.options[Number(i)] === sel[i]; });
        });
      }

      function actualizar() {
        var sel = seleccion();
        var variante = buscarVariante(sel);

        opciones.forEach(function (btn) {
          var prueba = Object.assign({}, sel);
          prueba[btn.getAttribute('data-mt-option-index')] = btn.getAttribute('data-mt-value');
          var posible = variants.some(function (v) {
            return Object.keys(prueba).every(function (i) { return v.options[Number(i)] === prueba[i]; });
          });
          btn.disabled = !posible;
          if (btn.tagName === 'INPUT' && btn.nextElementSibling) {
            btn.nextElementSibling.classList.toggle('is-disabled', !posible);
          }
        });

        if (!variante) {
          if (addBtn) {
            addBtn.disabled = true;
            addBtn.textContent = addBtn.getAttribute('data-mt-unavailable-text') || 'No disponible';
          }
          return;
        }

        if (idInput) idInput.value = variante.id;
        if (priceEl) priceEl.textContent = formatear(variante.price);
        if (compareEl) {
          if (variante.compare_at_price && variante.compare_at_price > variante.price) {
            compareEl.textContent = formatear(variante.compare_at_price);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
        if (addBtn) {
          if (variante.available) {
            addBtn.disabled = false;
            var texto = addBtn.getAttribute('data-mt-add-text') || 'Añadir';
            if (addBtn.hasAttribute('data-mt-precio-en-boton')) texto += ' · ' + formatear(variante.price);
            addBtn.textContent = texto;
          } else {
            addBtn.disabled = true;
            addBtn.textContent = addBtn.getAttribute('data-mt-soldout-text') || 'Agotado';
          }
        }

        var galeria = (seccion && seccion.querySelector('[data-mt-galeria]')) || document.querySelector('[data-mt-galeria]');
        if (!primeraPasada && galeria && galeria.__mtMostrarPorSrc && variante.featured_image) {
          galeria.__mtMostrarPorSrc(variante.featured_image.src);
        }

        document.dispatchEvent(new CustomEvent('mt:variante-actualizada'));
      }

      opciones.forEach(function (btn) {
        btn.addEventListener(btn.tagName === 'INPUT' ? 'change' : 'click', function () {
          if (btn.disabled) return;
          if (btn.tagName !== 'INPUT') {
            var idx = btn.getAttribute('data-mt-option-index');
            document.querySelectorAll('[data-mt-option-index="' + idx + '"]').forEach(function (b) {
              b.classList.remove('is-selected');
            });
            btn.classList.add('is-selected');
          }
          actualizar();
        });
      });

      actualizar();
      primeraPasada = false;
    });
  }

  /* ---------- Cantidad ---------- */
  function initQty() {
    document.querySelectorAll('[data-mt-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      if (!input) return;
      var form = wrap.closest('form');
      var menos = wrap.querySelector('[data-mt-qty-minus]');
      var mas = wrap.querySelector('[data-mt-qty-plus]');

      // Shopify deja meter en el carrito más unidades de las que hay y solo
      // avisa al pagar, así que el tope se pone aquí: nunca por encima del
      // stock real de la variante elegida.
      function limitar(n) {
        var stock = stockDe(form);
        var max = stock < 0 ? Infinity : Math.max(1, stock);
        return Math.min(Math.max(1, n), max);
      }

      if (menos) menos.addEventListener('click', function () {
        input.value = limitar((parseInt(input.value, 10) || 1) - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      if (mas) mas.addEventListener('click', function () {
        input.value = limitar((parseInt(input.value, 10) || 1) + 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      input.addEventListener('change', function () {
        var pedido = parseInt(input.value, 10) || 1;
        var valido = limitar(pedido);
        if (valido !== pedido) {
          input.value = valido;
          var el = avisoDe(form);
          var plantilla = el ? el.getAttribute('data-mt-texto-quedan') : '';
          var stock = stockDe(form);
          if (plantilla && stock >= 0) mostrarAviso(form, plantilla.replace('{n}', stock), false);
        }
      });
    });
  }

  /* ---------- Repintar y abrir el cajón del carrito ---------- */
  // Se usa cuando el carrito cambió pero Shopify no devolvió las secciones
  // (por ejemplo al añadir menos unidades de las pedidas): se piden aparte.
  function refrescarCajon(cajon) {
    var secciones = (cajon.getSectionsToRender ? cajon.getSectionsToRender() : [])
      .map(function (s) { return s.id; });
    if (!secciones.length) return Promise.resolve();

    var url = window.location.pathname + '?sections=' + encodeURIComponent(secciones.join(','));
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (cajon.classList) cajon.classList.remove('is-empty');
        if (cajon.renderContents) cajon.renderContents({ sections: sections });
      });
  }

  /* ---------- Añadir al carrito sin salir de la página ---------- */
  function initCarritoLateral() {
    var cajon = document.querySelector('cart-drawer');
    if (!cajon) return; // el tema está en modo "página de carrito"

    document.querySelectorAll('[data-mt-product-form]').forEach(function (form) {
      var boton = form.querySelector('[data-mt-add-btn]');

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (boton && boton.disabled) return;

        var textoOriginal = boton ? boton.textContent : '';
        if (boton) {
          boton.disabled = true;
          boton.setAttribute('aria-busy', 'true');
        }

        var datos = new FormData(form);
        // Shopify devuelve el HTML ya montado de estas secciones, que es lo que
        // el cajón necesita para repintarse sin recargar la página.
        var secciones = (cajon.getSectionsToRender ? cajon.getSectionsToRender() : [])
          .map(function (s) { return s.id; });
        if (secciones.length) {
          datos.append('sections', secciones.join(','));
          datos.append('sections_url', window.location.pathname);
        }

        fetch((window.routes && routes.cart_add_url) || '/cart/add', {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: datos
        })
          .then(function (r) { return r.json(); })
          .then(function (respuesta) {
            if (respuesta.status) {
              // Shopify responde con "status" tanto si no añadió nada como si
              // añadió menos de lo pedido por falta de existencias. En el
              // segundo caso el carrito SÍ cambió, así que hay que abrirlo
              // igualmente o el cliente cree que no ha pasado nada.
              mostrarAviso(form, respuesta.description || respuesta.message || 'No se pudo añadir.', false);
              if (boton) boton.textContent = textoOriginal;
              return refrescarCajon(cajon).catch(function () {});
            }
            if (cajon.classList) cajon.classList.remove('is-empty');
            if (cajon.renderContents) cajon.renderContents(respuesta);
            if (boton) boton.textContent = textoOriginal;
            mostrarAviso(form, '');
          })
          .catch(function () {
            // Si algo falla, se envía el formulario a la antigua para no dejar
            // al cliente sin poder comprar.
            form.submit();
          })
          .finally(function () {
            if (boton) {
              boton.disabled = false;
              boton.removeAttribute('aria-busy');
            }
          });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initGiro();
    initVideosSeccion();
    initGaleria();
    initTramos();
    initVariantes();
    initQty();
    initCarritoLateral();
  });
})();
